var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 400,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.data.status,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "status", $$v);
      },
      expression: "data.status"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "已通过"
    }
  }, [_vm._v("已通过")]), _c('Radio', {
    attrs: {
      "label": "不通过"
    }
  }, [_vm._v("不通过")])], 1)], 1), _c('FormItem', {
    attrs: {
      "prop": "remark",
      "label": "备注"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "textarea"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('remark');
      }
    },
    model: {
      value: _vm.data.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "remark", $$v);
      },
      expression: "data.remark"
    }
  })], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };